import {
  cnpjValidator,
  mobileValidator,
  phoneValidator
} from '@utils/document-validator'
import * as Yup from 'yup'

const schema = Yup.object().shape({
  name: Yup.string()
    .test('last-name-required', 'Insira o nome completo', (value: string) => {
      const hasLastName = !!value?.trim().split(' ')[1]
      return !value?.length || hasLastName
    })
    .test(
      'max-length-firstname',
      'O primeiro nome deve conter no máximo 40 caracteres',
      (value: string) => {
        const maxLengthFirstName = 40
        return (
          !value?.length || value?.split(' ')[0]?.length <= maxLengthFirstName
        )
      }
    )
    .test(
      'max-length-lastname',
      'O sobrenome deve conter no máximo 80 caracteres',
      (value: string) => {
        const maxLengthLastName = 80
        return (
          !value?.length ||
          value?.split(' ')?.slice(1)?.join(' ').length <= maxLengthLastName
        )
      }
    ),
  email: Yup.string()
    .email('Formato de e-mail incorreto')
    .required('Campo obrigatório'),
  phone: Yup.string()
    .test('is-phone', 'Telefone inválido', value => {
      const normalizedValue = value ? value.replace(/[^0-9]/g, '') : null
      return phoneValidator(normalizedValue) || mobileValidator(normalizedValue)
    })
    .required('Telefone é obrigatório'),
  document: Yup.string()
    .required('Campo obrigatório')
    .test('is-cnpj', 'CNPJ inválido', function (value) {
      return cnpjValidator(value?.replace(/\D/g, ''))
    }),
  consumerUnits: Yup.object()
    .required('Por favor escolha uma opção')
    .test('val', val => !!val)
})

export const FreeMarketLeadsSpecification = {
  schema
}
